import React from 'react';

// Naturalistic branching lightning bolt SVG that echoes the brand mark.
// Jagged organic paths with side-branches — no unwanted sky/cloud content.
export const LightningBolt = ({ className = '', color = '#E4C158', glowColor = 'rgba(228,193,88,0.55)', opacity = 0.85, style = {} }) => {
    return (
        <svg
            viewBox="0 0 300 900"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            preserveAspectRatio="xMidYMid meet"
            className={className}
            style={{ opacity, ...style }}
        >
            <defs>
                <filter id="lb-glow" x="-50%" y="-50%" width="200%" height="200%">
                    <feGaussianBlur stdDeviation="4" result="glow1" />
                    <feGaussianBlur stdDeviation="12" result="glow2" />
                    <feMerge>
                        <feMergeNode in="glow2" />
                        <feMergeNode in="glow1" />
                        <feMergeNode in="SourceGraphic" />
                    </feMerge>
                </filter>
                <linearGradient id="lb-grad" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#fff8d6" stopOpacity="1" />
                    <stop offset="45%" stopColor={color} stopOpacity="0.95" />
                    <stop offset="100%" stopColor={color} stopOpacity="0.35" />
                </linearGradient>
            </defs>

            {/* Outer diffuse glow */}
            <g filter="url(#lb-glow)" stroke={glowColor} strokeWidth="6" fill="none" strokeLinecap="round" strokeLinejoin="round" opacity="0.45">
                <path d="M172 10 L138 92 L166 118 L120 220 L156 236 L98 380 L134 400 L74 560 L108 578 L58 720 L88 738 L34 890" />
            </g>

            {/* Main bolt */}
            <g stroke="url(#lb-grad)" strokeWidth="2.4" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path d="M172 10 L138 92 L166 118 L120 220 L156 236 L98 380 L134 400 L74 560 L108 578 L58 720 L88 738 L34 890" />
            </g>

            {/* Bright core */}
            <g stroke="#ffffff" strokeWidth="1.1" fill="none" strokeLinecap="round" strokeLinejoin="round" opacity="0.9">
                <path d="M172 10 L138 92 L166 118 L120 220 L156 236 L98 380 L134 400 L74 560 L108 578 L58 720 L88 738 L34 890" />
            </g>

            {/* Branch 1 (upper-mid, forks right) */}
            <g stroke="url(#lb-grad)" strokeWidth="1.4" fill="none" strokeLinecap="round" strokeLinejoin="round" opacity="0.8">
                <path d="M156 236 L192 262 L178 300 L214 322 L200 356 L232 386" />
            </g>
            <g stroke="#ffffff" strokeWidth="0.6" fill="none" opacity="0.7">
                <path d="M156 236 L192 262 L178 300 L214 322 L200 356 L232 386" />
            </g>

            {/* Branch 2 (mid, small fork left) */}
            <g stroke="url(#lb-grad)" strokeWidth="1.2" fill="none" strokeLinecap="round" strokeLinejoin="round" opacity="0.7">
                <path d="M98 380 L64 402 L82 438 L52 470" />
            </g>

            {/* Branch 3 (lower fork right) */}
            <g stroke="url(#lb-grad)" strokeWidth="1.3" fill="none" strokeLinecap="round" strokeLinejoin="round" opacity="0.7">
                <path d="M74 560 L110 588 L94 622 L128 648 L114 680" />
            </g>

            {/* Tiny wisp branches for realism */}
            <g stroke="#fff5c9" strokeWidth="0.6" fill="none" opacity="0.5" strokeLinecap="round">
                <path d="M138 92 L124 108" />
                <path d="M120 220 L102 240" />
                <path d="M134 400 L152 418" />
                <path d="M108 578 L128 596" />
                <path d="M88 738 L102 756" />
                <path d="M192 262 L204 250" />
                <path d="M232 386 L246 400" />
                <path d="M64 402 L48 396" />
                <path d="M128 648 L142 660" />
            </g>
        </svg>
    );
};

export default LightningBolt;
